"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const hooks_1 = require("@app/store/external/application/hooks");
const hooks_2 = require("@app/store/external/transactions/hooks");
const object_1 = require("@utils/object");
const core_1 = require("@web3-react/core");
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const good_notification_1 = require("./components/good-notification");
const mining_1 = require("./components/mining");
const notification_1 = require("./components/notification");
require("./styles.scss");
const Notifications = () => {
    const container = document.getElementById("notification-container");
    (0, react_1.useEffect)(() => {
        const onScroll = () => {
            const container = document.querySelector(".c-notifications");
            if (container) {
                container.style.top = `${120 - window.pageYOffset < 10 ? 10 : 120 - window.pageYOffset}px`;
            }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    const popupList = (0, hooks_1.useActivePopups)();
    const allTxs = (0, hooks_2.useAllTransactions)();
    const { account } = (0, core_1.useWeb3React)();
    const allTransactions = Object.values(allTxs)
        .filter(hooks_2.isTransactionRecent)
        .sort((left, right) => right.addedTime - left.addedTime);
    const pendingTransactions = allTransactions.filter((tx) => !tx.receipt && (0, object_1.caseInsensitiveCompare)(account, tx.from));
    const removePopup = (0, hooks_1.useRemovePopup)();
    if (!container) {
        return null;
    }
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "c-notifications" },
        pendingTransactions.length > 0 && react_1.default.createElement(mining_1.Mining, { txCountPending: pendingTransactions.length }),
        popupList.map(({ key, content, removeAfterMs }) => {
            if ("txn" in content) {
                const { txn: { hash, success, summary }, } = content;
                return (react_1.default.createElement(notification_1.Notification, { key: key, removeAfterMs: removeAfterMs || 1000, hash: hash, success: success, popKey: key, summary: summary, remove: removePopup }));
            }
            else if ("good" in content) {
                const { good } = content;
                return (react_1.default.createElement(good_notification_1.GoodNotification, { key: key, removeAfterMs: removeAfterMs || 1000, popKey: key, remove: removePopup, tokenId: good.tokenId, title: good.title, price: good.price, tokenAddress: good.tokenAddress, previewSrc: good.previewSrc, isAdding: good.isAdding }));
            }
            else {
                return null;
            }
        })), container);
};
exports.Notifications = Notifications;
